import { useMutation } from "@tanstack/react-query";

import { sendNotification } from "../../api/notification.api";
import { MedicalNotificationPayload } from "../../medical/notification/notification.types";
import { useToastContext } from "../../containers/ToastContextWrapper";

export const useSendNotificationPayload = () => {
  const { showToast } = useToastContext();

  return useMutation({
    mutationFn: (payload: MedicalNotificationPayload) =>
      sendNotification(payload),
    onSuccess: () => {
      showToast({
        title: "Notification sent",
        description: "Custom payload delivered to the device.",
        type: "success",
      });
    },
    onError: (error: Error) => {
      console.error("Failed to send notification", error);
      showToast({
        title: "Couldn't send notification",
        description: "Please try again in a moment.",
        type: "error",
      });
    },
  });
};
